<template>
    <div>
        <div v-if="noTodo">
            {{ message }}
        </div>
        <div v-else>
            <!--
            <b-alert :variant="alertVariant" show>
                <b-form-checkbox
                        v-model="mandatoryControls">
                    J'ai réalisé tous les contrôles obligatoires
                </b-form-checkbox>
            </b-alert>
            -->
            <p>
                A réaliser pour le tiers {{ todo.client.name }} par
                {{ todo.assigned_to.name }} avant le :
            </p>
            <b-input-group class="mb-3">
                <b-form-input
                    id="current-date"
                    v-model="formatted_current_date"
                    type="text"
                    size="sm"
                    placeholder="Date à définir"
                    autocomplete="off"
                    disabled
                    class="bg-white"
                ></b-form-input>
                <b-input-group-append>
                    <b-form-datepicker
                        v-model="form.deadline_date"
                        button-only
                        right
                        size="sm"
                        label-no-date-selected="Date à définir"
                        label-prev-year="Année précédente"
                        label-next-year="Année prochaine"
                        label-prev-month="Mois précédent"
                        label-next-month="Mois prochain"
                        label-current-month="Mois actuel"
                        label-help="Vous pouvez utiliser les flèches du clavier pour naviguer"
                        start-weekday="1"
                        aria-controls="current-date"
                        locale="fr"
                        @context="formatCurrentDate"
                    >
                    </b-form-datepicker>
                </b-input-group-append>
            </b-input-group>
            <b-textarea v-model="form.description" size="sm" rows="5" />
            <div v-if="newTodo" class="row mt-3">
                <div class="col-6">
                    <b-button
                        variant="danger"
                        size="sm"
                        block
                        @click="removeTodo"
                    >
                        <i class="fal fa-trash-alt"></i> Effacer
                    </b-button>
                </div>
                <div class="col-6">
                    <b-button
                        variant="success"
                        size="sm"
                        block
                        @click="saveTodo"
                    >
                        <i class="fal fa-save"></i>Valider
                    </b-button>
                </div>
            </div>

            <div v-else class="row mt-3">
                <div class="col-6">
                    <b-button
                        variant="danger"
                        size="sm"
                        block
                        @click="removeTodo"
                    >
                        <i class="fal fa-trash-alt"></i> Effacer
                    </b-button>
                </div>
                <div class="col-6">
                    <b-button
                        variant="secondary"
                        size="sm"
                        block
                        @click="closeModal"
                    >
                        <i class="fal fa-times"></i> Annuler
                    </b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TodoForm',

    props: {
        deadline: {},
    },

    data() {
        return {
            todo: {},
            form: {},
            formatted_current_date: '',
            message: '',
            noTodo: false,
            // mandatoryControls: false
        }
    },

    computed: {
        newTodo() {
            return this.deadline.achieved_by !== null
        },

        alertVariant() {
            // return this.mandatoryControls
            // ? 'success'
            // : 'danger'
        },
    },

    created() {
        // console.log('init ToDoForm', Date.now())
        this.init()
    },

    methods: {
        init() {
            if (this.deadline.initiated_todo !== null) {
                this.todo = this.deadline.initiated_todo
                this.form.description = this.todo.description
                this.form.deadline_date = this.todo.deadline_date
            } else {
                this.noTodo = true
                if (this.newTodo) {
                    this.message = "La todo n'a pas pu être créée"
                } else {
                    this.message =
                        this.deadline.achievement_date === null
                            ? 'La todo associée a été supprimée'
                            : "Aucune todo n'est associée à cette échéance"
                }
            }
        },

        async saveTodo() {
            try {
                await axios.put(
                    `/clientEvents/deadline-task/${this.todo.id}`,
                    this.form
                )
                this.closeModal()
                this.$bvModal.show(`todo-modal-id${this.todo.id}`)
            } catch (error) {
                // handle error
                console.log(error)
            }
        },

        async removeTodo() {
            this.closeModal()
            try {
                await axios.delete(`/clientEvents/${this.todo.id}`)
            } catch (error) {
                // handle error
                console.log(error)
            }
        },

        formatCurrentDate(ctx) {
            this.formatted_current_date = ctx.selectedFormatted
            this.$store.commit(
                'timeSheetsVM/SET_CURRENT_DATE',
                this.form.current_date
            )
        },

        closeModal() {
            this.$bvModal.hide(`todo-modal-id${this.deadline.id}`)
        },
    },
}
</script>

<style scoped></style>
